// Frontend-only mirror of api/src/access-control/dto/access-control-config.dto.ts.
// Not synced via dto:sync — the backend DTO imports @nestjs/swagger decorators
// and a provider-enum file, both of which dto-syncer.js treats as backend-only.

export enum AccessControlProviderType {
  ENZO_CARD = 'enzo_card',
  NEOP = 'neop',
  TENKRAFT = 'tenkraft',
  IGLOOHOME = 'igloohome',
  SALTO = 'salto',
}

/**
 * Dashboard-facing config shape. Deliberately has no `credentials` field —
 * the backend never returns vendor secrets, only `hasCredentials`. See
 * docs/epics/access-control-abstraction.md and hardening status doc item C1.
 */
export type AccessControlConfigDto = {
  id: string;
  organizationId: string;
  locationId?: string;
  provider: AccessControlProviderType;
  hasCredentials: boolean;
  doorMappings: Record<string, string>;
  settings: Record<string, unknown>;
  enabled: boolean;
  createdAt: string;
  updatedAt: string;
};

/**
 * Request body for creating/updating a config. No `credentials` field on
 * purpose — the backend's ValidationPipe strips it even if sent. Setting real
 * vendor credentials goes through its own endpoint (C13), see
 * `SetAccessControlCredentialsDto` below.
 */
export type UpsertAccessControlConfigDto = {
  provider: AccessControlProviderType;
  locationId?: string;
  doorMappings?: Record<string, string>;
  settings?: Record<string, unknown>;
  enabled?: boolean;
};

/**
 * Request body for `PUT access-control/admin/config/:orgId/credentials` —
 * the narrow secret-write path (C13). Elevated (platform) admins only; the
 * API 403s everyone else. Values are write-only: the backend never returns
 * them, responses only carry `hasCredentials`.
 */
export type SetAccessControlCredentialsDto = {
  provider: AccessControlProviderType;
  locationId?: string;
  credentials: Record<string, unknown>;
};
